import { Component } from '@angular/core';
import { PDFDocument } from 'pdf-lib';
@Component({
  selector: 'app-pdf-senha',
  templateUrl: './pdf-senha.component.html',
  styleUrls: ['./pdf-senha.component.scss']
})
export class PdfSenhaComponent {
  resultado: boolean | null = null;

  async verificarPdf(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    const file = input.files[0];

    try {
      const arrayBuffer = await file.arrayBuffer();

      await PDFDocument.load(arrayBuffer);

      // Se chegou aqui, não tem senha
      this.resultado = false;

    } catch (error: any) {
      const msg = error?.message?.toLowerCase() ?? '';

      if (msg.includes('encrypted') || msg.includes('password')) {
        this.resultado = true; // PDF com senha
      } else {
        console.error('Erro ao ler PDF', error);
        this.resultado = null;
      }
    }
  }
}
